module.exports = __webpack_public_path__ + "static/media/youshi2.8bd9ab31.svg";


//////////////////
// WEBPACK FOOTER
// ./src/image/youshi2.svg
// module id = 38
// module chunks = 6